module.exports = __webpack_public_path__ + "img/price-tag.42613389.svg";